"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M653.8 634.8c-5-11.6-18.4-16.9-30-12-.3.1-.5.2-.8.4-41.8 20.6-93.9 31-154.8 31-151.7 0-243.1-65.1-274.7-191.8h219c13.1-.3 23.5-11.2 23.2-24.3.3-13.1-10-24-23.2-24.3H184c-2.3-19.6-4-39.8-4-61.8 0-12 1.5-22.5 2.2-33.9h230.2c13.1-.3 23.5-11.1 23.2-24.2v-.1c.3-13.1-10-24-23.2-24.3H187.2C211.8 124 305.6 49.6 468.2 49.6c60.2 0 111.7 10.3 153.3 30.4 11.7 5.6 25.4.4 30.8-11.8 5.4-12.1.4-26.2-11.3-32.3C593.2 12.7 535.1 1 468.2 1c-187.8 0-302 94.6-328.5 268.5H70.9c-13.1.3-23.5 11.2-23.2 24.3 0 13.4 10.4 24.3 23.2 24.3h63.9c-.6 11-1.2 22.2-1.2 33.9 0 21.7 1.4 42 3.5 61.8H70.9c-13.1.3-23.5 11.2-23.2 24.3 0 13.4 10.4 24.3 23.2 24.3h73.5c33.1 157.7 143.2 240.4 323.7 240.4 67.8 0 126.6-12 174.5-35.7 11.8-6.1 16.7-20.3 11.2-32.3"
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M607.7 602.9c-38.7 19.2-87.2 28.9-144 28.9-136.1 0-218.7-53.3-250.6-161.6h197c18.4 0 33.4-15.7 33.4-35.2 0-19.4-14.9-35.2-33.4-35.2H200.7c-1.4-15.5-2.9-30.8-2.9-47.9 0-7.4 1-13.8 1.3-21h211c18.4 0 33.4-15.7 33.4-35.2s-14.9-35.2-33.4-35.2H207.3C233.1 134.5 317 71.8 463.7 71.8c56.2 0 104.1 9.5 142.6 28.2 16.8 8.2 36.6.5 44.4-17.1 7.7-17.6.5-38.5-16.3-46.7C587.1 13.1 529.6 1.5 463.7 1.5c-183.6 0-296.3 91.3-325.1 259H81.8c-18.4 0-33.4 15.7-33.4 35.2s15 35.2 33.4 35.2h49.9c-.2 7-.7 13.8-.7 21 0 16.6.8 32.4 2.1 47.9H81.8c-18.4 0-33.4 15.7-33.4 35.2 0 19.4 15 35.2 33.4 35.2h62c35.9 150.5 146.3 231.9 319.8 231.9 66.8 0 124.8-12 172.5-35.6 16.7-8.3 23.9-29.2 16-46.8-7.8-17.6-27.6-25.2-44.4-16.8"
  })
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M651.9 606.7c-10.2-22.7-35.8-32.6-57.3-21.8-36 17.9-81.4 26.9-134.7 26.9-118.9 0-193.2-44.6-226.1-134h174.3c23.9 0 43-20.4 43-45.5s-19.2-45.4-43-45.4H215.8c-.7-11.6-2.1-22.6-2.1-35.1 0-3.2.5-5.8.6-8.9h193.8c23.9 0 43-20.4 43-45.5s-19.2-45.4-43-45.4H225.7C253.1 145.1 329.9 91.9 459.9 91.9c52.7 0 97.6 8.9 133.4 26.3 21.6 10.7 47.2.6 57.1-22.1 10-22.8.6-49.8-21-60.4C582.2 12.7 525.2 1 460 1 279.7 1 168 89.4 136.9 252.2h-46c-23.8 0-43 20.4-43 45.4 0 25.1 19.2 45.5 43 45.5H128c0 3-.3 5.8-.3 8.9 0 12 .5 23.6 1.2 35.1h-38c-23.8 0-43 20.3-43 45.4 0 25.1 19.2 45.5 43 45.5h51.7C180.4 623.9 289.7 702.8 460 702.8c66.2 0 123.8-11.9 171.4-35.6 21.5-10.7 30.6-37.8 20.5-60.5"
  })
});

var Euro = function Euro(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Euro-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '0 -6 715 715';
  }

  if (!mainDimension) {
    mainDimension = 'y';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Euro;
exports["default"] = _default;

//# sourceMappingURL=index.js.map